import { CatalogPriceLineZone } from "../models";
import { priceRequester as request } from "./requesters";

const catalogPriceLineZoneService = {
  createCatalogPriceLineZone: (data: CatalogPriceLineZone) => request.post(`/catalog-price-line-zones`, data),
};
export default catalogPriceLineZoneService;
